<template lang="pug">
	div
		.breadcrumbs
			//-.breadcrumb-back
				back-button
			.breadcrumb-link
				router-link.chapter(to="/") Home
			.breadcrumb-link(v-if="page !== 'About the Hukos'")
				router-link.chapter(to="/about-the-hukos") About the Hukos
			.breadcrumb-link(v-if="meta && meta.parent === 'magic'")
				router-link.chapter(to="/about-the-hukos/magic") Magic
			.breadcrumb-link
				| {{ page }}
		vue-page-transition(name="fade")
			router-view
</template>

<script>
import BackButton from '@/components/BackButton'

export default {
	name      : 'AboutTheHukosWrapper',
	components: {
		BackButton
	},
	data () {
		return {
			page: this.$route.name,
			meta: this.$route.meta
		}
	},
	mounted () {
		this.$store.commit('general/FIRST_RUN_ABOUT_HUKOS')
	},
	watch: {
		'$route' (val) {
			this.$nextTick(() => {
				this.page = this.$route.name
				this.meta = this.$route.meta

				if (document.activeElement) document.activeElement.blur()

				if (window.screen.width < 650) {
					this.$store.commit('general/FIRST_RUN_ABOUT_HUKOS', true)
				}
			})
		}
	}
}
</script>
